<template>
    <popup-widget
        ref="popup-widget"
        v-show="showNewsletterWidget"
        :iconPath="widgetIconPath"
        :defaultMode='`expanded`'
        :autoexpand='false'
        :autoexpandMs='2000'
        :closeByEsc='true'
        class="newsletter-popup-widget"
        :widgetColor="`var(--quomi-orange)`"
        :position="{
            bottom: position.bottom,
            right: position.right,
        }"
        :stopAutoexpand="!autoexpandNewsletterModal"
        @onMinimized="onMinimized"
        :showDelayMs='10000'
    >
        <template v-slot:modal-content>
            <newsletter-modal-content
                :recipeCoupon="recipeCoupon"
                @afterSuccess="afterSuccess"
                @hideCoupon="hideCoupon"
            />
        </template>
    </popup-widget>
</template>

<script>

import { newsletter } from '../../mixins/newsletter'
import { container } from '../../services/container'
import SocialShare from '../SocialShare/SocialShare'
import Checkbox from '../Checkbox'
import NewsletterModalContent from '../Marketing/NewsletterModalContent'

export default {
    data () {
        return {
            checked: false,
            email: null,

            widgetIconPath: require('../../assets/img/badges/popup-minimized/gift.png'),
            subscribed: false,

            position: {
                bottom: '20px',
                right: '20px'
            },
            recipeCoupon: false,
            openRecipeCoupon: false
        }
    },

    mixins: [
        newsletter
    ],

    components: {
        NewsletterModalContent,
        SocialShare,
        Checkbox
    },

    props: {
        activeModal: {
            type: String,
            default: null
        }
    },

    computed: {
        user () {
            return this.$root.user
        },

        showNewsletterWidget () {

            var cookies = container.get('services.cookies')

            var userIsNew = !this.user || this.user.email.includes('guest.quomi.it') || this.user.isNew()
            var isApp = this.$mq.isWV()
            var alreadySubscribed = cookies.get('magnews', '/')
            var isPageToShow = this.$route.meta.newsletterModal !== false
            if(this.openRecipeCoupon) {
                return !isPageToShow
            }
            if (this.user && this.user.source !== 'default') {
                return false;
            }

            return userIsNew && !isApp && !alreadySubscribed  && isPageToShow
        },

        autoexpandNewsletterModal () {
            var isPageToShow = this.$route.meta.newsletterModal !== false
            var isAnotherModalActive = this.activeModal
            return isPageToShow && !isAnotherModalActive
        }
    },

    methods: {
        saveToCookies () {
            container.get('services.cookies').set('magnews', 1)
        },

        afterSuccess () {
            this.saveToCookies()
            this.subscribed = true
        },
        onMinimized () {
            if (this.subscribed) this.$refs['popup-widget'].hide()
        },
        hideCoupon() {
            this.$refs['popup-widget'].hide()
        }
    },
    created() {
        window.addEventListener('openRecipeCoupon', ()=>{
            this.openRecipeCoupon = true
            this.recipeCoupon = true
        });
    },
    destroyed() {
        window.removeEventListener('openRecipeCoupon', ()=>{
            this.openRecipeCoupon = true
            this.recipeCoupon = true
        });
    }
}

</script>

<style>
[data-freshdesk="true"] #popup-widget {
    bottom: 90px !important;
}

[data-wishlist-widget="true"] #popup-widget {
    display: none;
}

.newsletter-popup-widget .modal-container {
    max-width: 500px !important;
    border: 5px solid var(--quomi-primary);
}

@media(min-width: 1024px) and (max-width: 1439px) {
.newsletter-popup-widget .modal-container {
    max-width: 350px !important;
}
}

@media(min-width: 1440px) {

.modal-container {
    width: 350px !important;
}

.newsletter-popup-widget 
.modal-container.to-center {
position: fixed;
left: 13%;
top: 50%;
}

}
</style>
